var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextShrinker',{attrs:{"value":_vm.user.bio},on:{"click":_vm.openBioSidebar},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var text = ref.text;
return [_c('div',{staticClass:"profile__user__quote"},[_vm._v(_vm._s(text))])]}},{key:"buttonText",fn:function(){return [_vm._v("ver bio")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }